(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pvlog', {
            parent: 'entity',
            url: '/pvlog?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.pvlog.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pvlog/pvlogs.html',
                    controller: 'PvlogController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pvlog');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('pvlog-detail', {
            parent: 'pvlog',
            url: '/pvlog/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.pvlog.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pvlog/pvlog-detail.html',
                    controller: 'PvlogDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pvlog');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Pvlog', function($stateParams, Pvlog) {
                    return Pvlog.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'pvlog',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('pvlog-detail.edit', {
            parent: 'pvlog-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pvlog/pvlog-dialog.html',
                    controller: 'PvlogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pvlog', function(Pvlog) {
                            return Pvlog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pvlog.new', {
            parent: 'pvlog',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pvlog/pvlog-dialog.html',
                    controller: 'PvlogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fecha: null,
                                nroterminal: null,
                                versiondesoft: null,
                                cpuserial: null,
                                cputemp: null,
                                cpureboot: null,
                                tottxbytes: null,
                                toterrconex: null,
                                serialok: null,
                                serialreopen: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('pvlog', null, { reload: 'pvlog' });
                }, function() {
                    $state.go('pvlog');
                });
            }]
        })
        .state('pvlog.edit', {
            parent: 'pvlog',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pvlog/pvlog-dialog.html',
                    controller: 'PvlogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pvlog', function(Pvlog) {
                            return Pvlog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pvlog', null, { reload: 'pvlog' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pvlog.delete', {
            parent: 'pvlog',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pvlog/pvlog-delete-dialog.html',
                    controller: 'PvlogDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Pvlog', function(Pvlog) {
                            return Pvlog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pvlog', null, { reload: 'pvlog' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
